import Button from '@/components/atoms/button/button';
import Checkbox from '@/components/atoms/checkbox/checkbox';
import Tooltip from '@/components/atoms/tooltip/tooltip';
import './cardConfirm.scss';

const CardConfirm = ({
  content,
  numeroReferencia,
  onClickButton,
  handleCheckbox,
  checkedState,
  setCurrentStep,
}: any) => {
  const isACardSelected = () => {
    return checkedState.some((item: any) => item === true);
  };

  const renderNumeroReferencia = () => {
    if (Array.isArray(numeroReferencia)) {
      return numeroReferencia.map((referencia: any, index: number) => (
        <div
          key={index}
          className={`m-cardConfirm__container__reference__numberContainer${
            checkedState[index] === false && isACardSelected() ? '--disabled' : ''
          }`}
          onClick={() => handleCheckbox(index)}
        >
          <div className="m-cardConfirm__container__reference__numberContainer__checkbox">
            <Checkbox
              checkActive={checkedState[index]}
              square
              className="m-cardConfirm__container__reference__numberContainer__checkbox__check"
              checkClick={() => {
                handleCheckbox(index);
              }}
            />
          </div>
          <div className="m-cardConfirm__container__reference__numberContainer__reference">
            <h3>Número de referencia</h3>
            <p>No. {referencia}</p>
          </div>
        </div>
      ));
    }
    return (
      <div className="m-cardConfirm__container__reference__numberContainer">
        <p>{numeroReferencia}</p>
      </div>
    );
  };

  return (
    <div className="m-cardConfirm__container">
      <div className="m-cardConfirm__container__header">
        <h2>
          {content.referencias[5].nombre}{' '}
          <Tooltip content={content.referencias[5].tituloEnriquecido.raw} />
        </h2>
        <p>{content.referencias[5]?.subtitulo}</p>
      </div>
      <div className="m-cardConfirm__container__reference">
        <div className="m-cardConfirm__container__reference__cards">{renderNumeroReferencia()}</div>
      </div>
      <div className="m-cardConfirm__container__button">
        <Button
          type="button"
          classname="m-cardConfirm__container__button__btn primary"
          text="Volver"
          isDisabled={false}
          onClickAction={() => setCurrentStep(0)}
        />
        <Button
          type="button"
          classname="m-cardConfirm__container__button__btn secondary"
          text={content.referencias[2]?.boton[0].copy ?? ''}
          isDisabled={false}
          onClickAction={onClickButton}
        />
      </div>
    </div>
  );
};

export default CardConfirm;
